import React from 'react'

import { InfoWindow as BaseInfoWindow, InfoWindowProps } from '@react-google-maps/api'

export const InfoWindow: React.FC<InfoWindowProps & React.PropsWithChildren> = (props) => {
  return <BaseInfoWindow {...props} />
}
